import { auth, db } from '../firebase/config.ts';
import { signInWithRedirect, signInWithPopup, GoogleAuthProvider, getRedirectResult } from 'firebase/auth';
import type { User } from 'firebase/auth';
import { doc, getDoc } from 'firebase/firestore';
import { isAllowlistedAdminEmail } from '../config/adminAllowlist.ts';

async function assertAdminAccess(user: User): Promise<void> {
  // Ensure ID token is attached to Firestore requests (avoids permission-denied right after redirect/popup).
  await user.getIdToken(true);
  const adminDoc = await getDoc(doc(db, 'admins', user.uid));
  if (adminDoc.exists() || isAllowlistedAdminEmail(user.email)) return;
  await auth.signOut();
  throw new Error('Unauthorized access. Admin privileges required.');
}

export const authService = {
  async initiateGoogleSignIn() {
    const provider = new GoogleAuthProvider();
    await signInWithRedirect(auth, provider);
  },
  
  async getRedirectResult() {
    try {
      const result = await getRedirectResult(auth);
      
      if (result) {
        console.log("User authenticated with UID:", result.user.uid);
        console.log("User email:", result.user.email);
        await assertAdminAccess(result.user);
        return result.user;
      }
      return null;
    } catch (error) {
      console.error("Redirect result error:", error);
      throw error;
    }
  },

  // Keep the popup method as a fallback
  async signInWithGoogle() {
    const provider = new GoogleAuthProvider();
    const result = await signInWithPopup(auth, provider);
    
    console.log("User authenticated with UID:", result.user.uid);
    console.log("User email:", result.user.email);
    await assertAdminAccess(result.user);
    return result.user;
  },

  async signOut() {
    return auth.signOut();
  }
}; 